import React from "react";
import TextField from "../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import LocalCombobox from "../Reusable/LocalCombobox";
import NumberField from "../Reusable/NumberField";
import { Default } from "react-toastify/dist/utils";
const ProductTypeForm = ({
  register,
  errors,
  setValue,
  getValues,
  clearErrors,
}: any) => {
  const UnitData = [
    { id: "Kg", name: "Kg" },
    {
      id: "Gm",
      name: "Gm",
    },
  ];
  return (
    <>
      <div className={tw`grid grid-cols-2 gap-x-4 mx-4`}>
        <TextField
          label={"Name"}
          register={register("name")}
          errors={errors?.name}
        />
        <TextField
          label={"VCTS Name"}
          register={register("vcts_name")}
          errors={errors?.description}
        />

        <LocalCombobox
          data={UnitData}
          errors={errors?.unit}
          setValue={setValue}
          register={register("unit")}
          name={"unit"}
          label={"Unit"}
          getValues={getValues}
          clearErrors={clearErrors}
          value={getValues("unit")}
        />
        <NumberField
          value={getValues("default_value")}
          register={register("default_value")}
          errors={errors?.default_value}
          label={"Default Value"}
          setValue={setValue}
          clearErrors={clearErrors}
        />
      </div>
    </>
  );
};

export default ProductTypeForm;
